'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimArrayPrototypeIncludes() {
	var polyfill = getPolyfill();
	define(
		Array.prototype,
		{ includes: polyfill },
		{ includes: function () { return Array.prototype.includes !== polyfill; } }
	);
	return polyfill;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/array-includes/shim.js
 ** module id = 1821
 ** module chunks = 0
 **/